export const environment = {
    apiBaseUrl: 'API_BASE_URL',
  
    // strings
    customer: '__CUSTOMER__',
    pageTitle: '__PAGE_TITLE__',
    tokenIdWall: '__TOKEN_IDWALL__',
    tokenDidit: '__TOKEN_DIDIT__',
    projectName: '__PROJECT_NAME__',
    firstRoute: '__FIRST_ROUTE__',
    graphUrl: '__GRAPH_URL__',
    showGraph: '__BOOL_SHOW_GRAPH__',                 // boolean via placeholder
    pixelId: '__PIXEL_ID__',
    BankingCheckout: '__BOOL_BANKING_CHECKOUT__',     // boolean via placeholder
    baseUrl: '__BASE_URL__',
    showAccountImage: '__BOOL_SHOW_ACCOUNT_IMAGE__',  // boolean via placeholder
    isKrakenIntegrationEnabled: '__BOOL_KRAKEN__',    // boolean via placeholder
    isBinanceIntegrationEnabled: '__BOOL_BINANCE__',  // boolean via placeholder
    signupExternal: '__BOOL_SIGNUP_EXTERNAL__',       // boolean via placeholder
    collectionId: '__COLLECTION_ID__',
    tokenExchange: '__TOKEN_EXCHANGE__',
    signupURL: '__SIGNUP_URL__',
    WS_ENDPOINT: '__WS_ENDPOINT__',
    decimalPlaces: '__DECIMAL_PLACES__',
    oneSignalId: '__ONESIGNAL_ID__',
    decimalsPlacesBought: '__NUM_DECIMALS_BOUGHT__',  // number via placeholder
    mainRoute: '__MAIN_ROUTE__',
    showHeaderBuy: '__BOOL_SHOW_HEADER_BUY__',        // boolean via placeholder
    companyName: '__COMPANY_NAME__',
    cnpj: '__CNPJ__',
    billNameCompany: '__BILL_NAME_COMPANY__',
    waterMark: '__BOOL_WATERMARK__',                  // boolean via placeholder
    webService: '__WEB_SERVICE__',
    priority: '__PRIORITY__',
    climateClock: '__BOOL_CLIMATE_CLOCK__',           // boolean via placeholder
    marketPlaceFooterLine1: '__FOOTER_LINE_1__',
    marketPlaceFooterLine2: '__FOOTER_LINE_2__',
    marketPlaceFooterLine3: '__FOOTER_LINE_3__',
    marketPlaceFooterLine4: '__FOOTER_LINE_4__',
    enableWithdrawFiatShortcut: '__BOOL_WITHDRAW_SHORTCUT__', // boolean
    hidePlataformMetrics: '__BOOL_HIDE_PLATAFORM_METRICS__', // boolean
    languageDefault: '__LANGUAGE_DEFAULT__' // pt-br | en | es
  };
  
